import goushala1 from "../../../assets/images/goushala1.jpg";
import goushala2 from "../../../assets/images/goushala2.jpg";
import goushala3 from "../../../assets/images/goushala3.jpg";
import goushala4 from "../../../assets/images/goushala4.jpg";
import goushala5 from "../../../assets/images/goushala5.jpg";
import goushala6 from "../../../assets/images/goushala6.jpg";

export const goverdhangoushalaImages = [
  {
    id: 1,
    image: goushala1,
  },
  {
    id: 2,
    image: goushala2,
  },
  {
    id: 3,
    image: goushala3,
  },
  {
    id: 4,
    image: goushala4,
  },
  {
    id: 5,
    image: goushala5,
  },
  {
    id: 6,
    image: goushala6,
  },
];

export const goushala = [
  "The Goverdhan goushala at ISKCON is a haven for cows, providing them with a safe and loving environment where they can thrive and live out their lives in peace. Located on thegrounds of the temple, the goushala is home to a herd of cows who are treated with the almost care and respect.",

  "We are currently serving more than 110 Deshi Cows wholeheartedly, where they are brought from surrounding areas sometimes in critical need for care, sometimes being abandoned because they cannot be milked further, and sometimes the caretakers leaving then with us because they cannot keep them anymore.",

  "We accept these cows and our team led by Gau-premi H.G Laxmikant Das render selfless service to gau mata.",

  "Visitors to the goushala are immediately struck by the serene and peaceful atmosphere,which is filled with the gentle sound of mooing cows and the rustling of leaves in the breeze.The cows roam freely throughout the spacious grounds, grazing on fresh grass and enjoying the sunshine.",

  "The goushala is not just a sanctuary for cows, however - it is also a place of learning and inspiration for visitors. Guests can take part in guided tours of the facility, where they can learn about the importance of cow protection and the vital role that cows play in Vedic culture.",

  "The goushala also serves as a model for sustainable and environmentally friendly practices.The cows are raised using organic and natural methods, and their waste is recycled to create compost and other valuable resources.",

  "But perhaps the most powerful aspect of the goushala is the sense of connection and reverence that it inspires in visitors. Cows are considered sacred in Vedic culture, and the goushala provides a tangible and meaningful way for people to connect with this tradition and to develop a deeper appreciation for the natural world and the divine presence that permeates it.",

  "The goushala at ISKCON is a beautiful and inspiring testament to the power of compassion, sustainability, and spiritual connection. Whether you are a devotee of Lord Krishna or simply someone who appreciates the beauty and majesty of the natural world, a visit to the goushala is sure to leave a lasting impression on your heart and mind.",

  "Contact Details:",

  "H. G. Laxmikant Das : ",
];

export const contactDetails = [{ id: 1, number: " +91 9429664102" }];
